import React from "react";
import { Container, Row } from "react-bootstrap";

const PaymentPage = () => {
  return (
    <div>
      <Container>
        <Row>
          <h2 style={{ textAlign: "center" }}>
            Uspješno ste platili objavu umrlice!
          </h2>
        </Row>
        <Row>
          {" "}
          <a style={{ textAlign: "center" }} href="/">
            Vrati se na početnu
          </a>{" "}
        </Row>
      </Container>
    </div>
  );
};

export default PaymentPage;
